import { render, staticRenderFns } from "./DeleteConfirmDialog.vue?vue&type=template&id=b60a7936&scoped=true"
import script from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"
export * from "./DeleteConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteConfirmDialog.vue?vue&type=style&index=0&id=b60a7936&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60a7936",
  null
  
)

export default component.exports